const FR = {
  login: {
    key: "login",
    screenLabel: "Aide — Connexion",
    purpose: "Entrer dans le cockpit privé du groupe.",
    actions: ["Utilisez votre identifiant en minuscules", "Les comptes du groupe utilisent le mot de passe du groupe"],
    nextStep: "Vous arrivez sur l'accueil.",
  },
  mapFull: {
    key: "mapFull",
    screenLabel: "Aide — Carte",
    purpose: "Revoir le secteur 4, l’historique et les photos. Les nouveaux points se créent dans NordQuest.",
    actions: ["+ Point stratégique", "Voir tout le secteur", "Ma position", "Filtres et couches"],
    nextStep: "Les nouveaux points terrain se créent dans NordQuest.",
  },
  today: {
    key: "today",
    screenLabel: "Aide — Accueil",
    purpose: "Savoir si on est prêts, quoi faire aujourd’hui, et quoi faire si un orignal est récolté.",
    actions: [
      "Préparation : permis, NordQuest, matériel, départ",
      "Le matin : météo, vent, plan du jour, lunch, souper",
      "Sources officielles — Québec, chasse à l’orignal : https://www.quebec.ca/tourisme-loisirs-sport/activites-sportives-et-de-plein-air/chasse-sportive/gibier/orignal",
      "Sources officielles — périodes 2026 : https://www.quebec.ca/tourisme-loisirs-sport/activites-sportives-et-de-plein-air/chasse-sportive/periodes-limites/orignal",
      "Sources officielles — enregistrement du gibier : https://www.quebec.ca/tourisme-loisirs-sport/activites-sportives-et-de-plein-air/chasse-sportive/regles-generales/enregistrement-gibier/comment-enregistrer-gibier",
      "Sources officielles — dossard : https://www.quebec.ca/tourisme-loisirs-sport/activites-sportives-et-de-plein-air/chasse-sportive/regles-generales/dossard",
      "Sources officielles — Sépaq Portneuf : https://www.sepaq.com/rf/por/",
      "Sources officielles — fiche technique du séjour, dans l’application",
      "Les règles peuvent changer. Chaque chasseur vérifie son permis et les modalités.",
    ],
    nextStep: "Ouvrez Chasse 2026 pour le chapitre complet.",
  },
  territory: {
    key: "territory",
    screenLabel: "Aide — Territoire",
    purpose: "Poser et retrouver les points GPS du terrain.",
    actions: ["La carte sert à revoir la prospection et les photos", "Les nouveaux points se créent dans NordQuest", "Ouvrez Préparation → NordQuest pour les 9 points"],
    nextStep: "Les nouveaux points terrain se créent dans NordQuest.",
  },
  photos: {
    key: "photos",
    screenLabel: "Aide — Photos",
    purpose: "Importer des photos avec date et GPS si l'appareil les a gardés.",
    actions: ["Ajoutez une photo", "Choisissez une catégorie", "Les métadonnées EXIF sont conservées"],
    nextStep: "Une photo GPS peut créer un point territoire.",
  },
  trip: {
    key: "trip",
    screenLabel: "Aide — Prospection",
    purpose: "Revoir le week-end de prospection au Chalet Desrochers.",
    actions: ["Voir les photos, points et souvenirs", "Ouvrir la fiche Sépaq", "Distinguer les 7 personnes présentes à la prospection"],
    nextStep: "La chasse 2026 n'a pas encore de date.",
  },
  hunt: {
    key: "hunt",
    screenLabel: "Aide — Chasse 2026",
    purpose: "Voir où on en est : prospection terminée, préparation en cours.",
    actions: ["Lire la timeline", "Ouvrir la prospection", "Préparer la chasse sans inventer de date"],
    nextStep: "Revenez à l'accueil pour la prochaine étape.",
  },
  souvenirs: {
    key: "souvenirs",
    screenLabel: "Aide — Souvenirs",
    purpose: "Garder les photos et anecdotes du week-end.",
    actions: ["Parcourir la galerie", "Lire les souvenirs importés", "Rien de technique ici"],
    nextStep: "Les photos restent aussi dans Photos.",
  },
  prep: {
    key: "prep",
    screenLabel: "Aide — Préparation",
    purpose: "Savoir ce qui est prêt, ce qui manque, et qui apporte quoi.",
    actions: ["Marquer un item Prêt puis Chargé", "Filtrer Moi ou Critique", "Ouvrir le mode Chargement avant le départ"],
    nextStep: "Ouvre Préparer mon NordQuest pour les 9 points du groupe.",
  },
  myStuff: {
    key: "myStuff",
    screenLabel: "Aide — Mes affaires",
    purpose: "Voir uniquement ce que VOUS devez apporter.",
    actions: ["Items assignés", "Tâches", "Nourriture si vous êtes concerné"],
    nextStep: "Revenez à la préparation pour assigner un autre item.",
  },
  lodging: {
    key: "lodging",
    screenLabel: "Aide — Hébergement",
    purpose: "Voir le Chalet Desrochers et la source officielle Sépaq.",
    actions: ["Ouvrir la page Sépaq", "Voir les photos officielles sur Sépaq", "Ouvrir la carte du secteur"],
    nextStep: "Les photos Sépaq restent sur leur site.",
  },
  group: {
    key: "group",
    screenLabel: "Aide — Groupe",
    purpose: "Voir les 6 membres officiels et les personnes associées.",
    actions: ["Luc et Éric organisent", "Josée, Natalie et Chantal sont personnes associées, pas chasseurs"],
    nextStep: "Ouvrez Plus pour écrire ou partager une dépense.",
  },
  more: {
    key: "more",
    screenLabel: "Aide — Plus",
    purpose: "Accéder aux écrans secondaires sans alourdir la barre mobile.",
    actions: ["Messages", "Dépenses", "Documents", "Historique", "Paramètres"],
    nextStep: "Revenez à l'accueil.",
  },
  messages: {
    key: "messages",
    screenLabel: "Aide — Messages",
    purpose: "Parler dans les canaux du groupe. L'historique Messenger reste non officiel.",
    actions: ["Choisissez un canal", "Écrivez un message", "Une réaction est possible"],
    nextStep: "Un message pourra plus tard devenir tâche, dépense ou point.",
  },
  expenses: {
    key: "expenses",
    screenLabel: "Aide — Dépenses",
    purpose: "Savoir qui a payé et qui doit rembourser.",
    actions: ["Ajoutez une dépense", "Le partage égal est le défaut", "Le total et les dettes se calculent"],
    nextStep: "Reliez la dépense à la sortie active.",
  },
  documents: {
    key: "documents",
    screenLabel: "Aide — Documents",
    purpose: "Garder permis, cartes et notes au même endroit.",
    actions: ["La liste se trie et se filtre", "Les vrais fichiers arriveront progressivement"],
    nextStep: "Ajoutez un document quand vous en avez un.",
  },
  history: {
    key: "history",
    screenLabel: "Aide — Historique",
    purpose: "Voir ce qui a changé depuis votre dernière visite.",
    actions: ["Recherchez une action", "Filtrez par type"],
    nextStep: "Le journal reste dans Administration.",
  },
  settings: {
    key: "settings",
    screenLabel: "Aide — Paramètres",
    purpose: "Voir la version, l'environnement et le commit, sans secrets.",
    actions: ["DEV Allemagne et PROD Québec doivent afficher le même commit", "Changez votre mot de passe ici"],
    nextStep: "Signalez un écart de version à Marcel.",
  },
  trips: {
    key: "trips",
    screenLabel: "Aide — Séjours",
    purpose: "Voir toutes les sorties et leur statut.",
    actions: ["Préparation, confirmée, en cours, terminée", "Ouvrez la sortie active pour le détail"],
    nextStep: "Le séjour officiel est le 28–30 août 2026.",
  },
  observations: {
    key: "observations",
    screenLabel: "Aide — Observations",
    purpose: "Noter ce que vous voyez sur le terrain, avec GPS si possible.",
    actions: ["Utilisez ma position", "Choisissez l'intérêt", "Marquez à revisiter"],
    nextStep: "Une photo peut être liée ensuite.",
  },
  tasks: {
    key: "tasks",
    screenLabel: "Aide — Tâches",
    purpose: "Organiser le travail du groupe. Marcel assigne. L'assigné complète.",
    actions: ["Créer une tâche et l'assigner", "L'assigné change le statut et commente", "Les tâches ouvertes apparaissent sur le cockpit"],
    nextStep: "Une tâche assignée crée une notification interne.",
  },
  gear: {
    key: "gear",
    screenLabel: "Aide — Matériel",
    purpose: "Liste partagée du matériel. Aucun item inventé.",
    actions: ["Ajoutez seulement ce qui est réel", "Statuts : à apporter, prêt, chargé"],
    nextStep: "Cochez chargé le matin du départ.",
  },
  search: {
    key: "search",
    screenLabel: "Aide — Recherche",
    purpose: "Retrouver un message, une photo, un point ou un membre.",
    actions: ["Tapez Desrochers ou Portneuf", "Ouvrez le séjour, le chalet ou une ressource"],
    nextStep: "La recherche reste simple et interne.",
  },
  notifications: {
    key: "notifications",
    screenLabel: "Aide — Notifications",
    purpose: "Voir les mentions, tâches assignées et sorties modifiées.",
    actions: ["Pas de push externe pour l'instant"],
    nextStep: "Revenez à l'accueil pour agir.",
  },
  admin: {
    key: "admin",
    screenLabel: "Aide — Administration",
    purpose: "Inviter un membre et voir la santé du système.",
    actions: ["N'inventez pas d'email", "Un membre sans mot de passe reste en invitation"],
    nextStep: "La version DEV et PROD doit être identique.",
  },
  member: {
    key: "member",
    screenLabel: "Aide — Membre",
    purpose: "Voir les contributions d'un membre, sans profil social.",
    actions: ["Photos, tâches, dépenses"],
    nextStep: "Éric est organisateur officiel avec Luc.",
  },
  menu: {
    key: "menu",
    screenLabel: "Aide — Menu",
    purpose: "Voir tous les repas du weekend et qui s'en occupe.",
    actions: ["Josée organise la nourriture", "Natalie prépare le déjeuner samedi", "Chacun apporte ses boissons"],
    nextStep: "Ouvrez Dépenses pour entrer un total commun.",
  },
  know: {
    key: "know",
    screenLabel: "Aide — À savoir",
    purpose: "Lire les règles confirmées avant de partir.",
    actions: ["Eau non potable", "Literie à apporter", "Vérifier SOPFEU le jour du départ"],
    nextStep: "Cochez ensuite la préparation.",
  },
  vehicles: {
    key: "vehicles",
    screenLabel: "Aide — Véhicules",
    purpose: "Voir les photos réelles des côte-à-côte. Les propriétaires restent à compléter.",
    actions: ["Véhicule 1 et Véhicule 2", "Aucun modèle inventé"],
    nextStep: "Compléter propriétaire et conducteur quand c'est connu.",
  },
  nordquest: {
    key: "nordquest",
    screenLabel: "Comment installer mes points dans NordQuest ?",
    purpose: "Installer NordQuest et récupérer les 9 points officiels d’Éric.",
    actions: [
      "Installer NordQuest",
      "Ouvrir Portneuf, secteur 4",
      "Télécharger les 9 points",
      "Importer le fichier KML",
      "Vérifier les 9 points",
      "Préparer la carte hors ligne",
    ],
    nextStep: "Coche Je suis prêt quand les 9 points sont sur ta carte.",
  },
};

const EN = {
  login: {
    key: "login",
    screenLabel: "Help — Sign in",
    purpose: "Enter the private group cockpit.",
    actions: ["Use your username in lowercase", "Group accounts use the group password"],
    nextStep: "You land on Home.",
  },
  mapFull: {
    key: "mapFull",
    screenLabel: "Help — Map",
    purpose: "Review sector 4, the history and the photos. New points are created in NordQuest.",
    actions: ["+ Strategic point", "See the whole sector", "My position", "Filters and layers"],
    nextStep: "New field points are created in NordQuest.",
  },
  today: {
    key: "today",
    screenLabel: "Help — Home",
    purpose: "See if we are ready, what today requires, and what to do if a moose is taken.",
    actions: ["Prep: permit, NordQuest, gear, departure", "Morning: weather, wind, day plan, lunch, supper", "Official sources: Quebec moose page, 2026 periods, game registration, fluorescent vest, Sépaq Portneuf, the stay sheet"],
    nextStep: "Open Hunt 2026 for the full chapter.",
  },
  territory: {
    key: "territory",
    screenLabel: "Help — Territory",
    purpose: "Drop and find GPS points in the field.",
    actions: ["Use the map to review scouting and photos", "New points are created in NordQuest", "Open Prep → NordQuest for the 9 points"],
    nextStep: "New field points are created in NordQuest.",
  },
  photos: {
    key: "photos",
    screenLabel: "Help — Photos",
    purpose: "Import photos with date and GPS when the camera kept them.",
    actions: ["Add a photo", "Pick a category", "Original EXIF metadata is kept"],
    nextStep: "A GPS photo can create a territory point.",
  },
  trip: {
    key: "trip",
    screenLabel: "Help — Scouting",
    purpose: "Review the scouting weekend at Desrochers Cabin.",
    actions: ["See photos, points and memories", "Open the Sépaq page", "Keep the 8 weekend people distinct from the 6 hunters"],
    nextStep: "The 2026 hunt has no date yet.",
  },
  hunt: {
    key: "hunt",
    screenLabel: "Help — Hunt 2026",
    purpose: "See where we stand: scouting done, preparation underway.",
    actions: ["Read the timeline", "Open scouting", "Prepare the hunt without inventing a date"],
    nextStep: "Go back to Home for the next step.",
  },
  souvenirs: {
    key: "souvenirs",
    screenLabel: "Help — Memories",
    purpose: "Keep the weekend photos and stories.",
    actions: ["Browse the gallery", "Read imported memories", "Nothing technical here"],
    nextStep: "Photos also stay in Photos.",
  },
  prep: {
    key: "prep",
    screenLabel: "Help — Prep",
    purpose: "See what is ready, what is missing, and who brings what.",
    actions: ["Mark an item Ready then Loaded", "Filter Me or Critical", "Open Loading mode before leaving"],
    nextStep: "Open Set up my NordQuest for the group's 9 points.",
  },
  myStuff: {
    key: "myStuff",
    screenLabel: "Help — My kit",
    purpose: "See only what YOU must bring.",
    actions: ["Assigned items", "Tasks", "Food if it concerns you"],
    nextStep: "Return to prep to assign another item.",
  },
  lodging: {
    key: "lodging",
    screenLabel: "Help — Lodging",
    purpose: "See Desrochers Cabin and the official Sépaq source.",
    actions: ["Open the Sépaq page", "View official photos on Sépaq", "Open the sector map"],
    nextStep: "Sépaq photos stay on their site.",
  },
  group: {
    key: "group",
    screenLabel: "Help — Group",
    purpose: "See the 6 official members and associated people.",
    actions: ["Luc and Éric organize", "Josée, Natalie and Chantal are associated people, not hunters"],
    nextStep: "Open More to write or share an expense.",
  },
  more: {
    key: "more",
    screenLabel: "Help — More",
    purpose: "Reach secondary screens without crowding the mobile bar.",
    actions: ["Messages", "Expenses", "Documents", "History", "Settings"],
    nextStep: "Go back to Home.",
  },
  messages: {
    key: "messages",
    screenLabel: "Help — Messages",
    purpose: "Talk in group channels. Messenger history stays unofficial.",
    actions: ["Pick a channel", "Write a message", "A reaction is available"],
    nextStep: "A message may later become a task, expense or point.",
  },
  expenses: {
    key: "expenses",
    screenLabel: "Help — Expenses",
    purpose: "Know who paid and who should reimburse.",
    actions: ["Add an expense", "Equal split is the default", "Totals and debts are computed"],
    nextStep: "Link the expense to the active stay.",
  },
  documents: {
    key: "documents",
    screenLabel: "Help — Documents",
    purpose: "Keep permits, maps and notes in one place.",
    actions: ["The list can be sorted and filtered", "Real files will arrive gradually"],
    nextStep: "Add a document when you have one.",
  },
  history: {
    key: "history",
    screenLabel: "Help — History",
    purpose: "See what changed since your last visit.",
    actions: ["Search an action", "Filter by type"],
    nextStep: "The log stays in Admin.",
  },
  settings: {
    key: "settings",
    screenLabel: "Help — Settings",
    purpose: "See version, environment and commit, without secrets.",
    actions: ["DEV Germany and PROD Quebec should show the same commit", "Change your password here"],
    nextStep: "Report a version gap to Marcel.",
  },
  trips: {
    key: "trips",
    screenLabel: "Help — Trips",
    purpose: "See every stay and its status.",
    actions: ["Preparation, confirmed, in progress, done", "Open the active stay for details"],
    nextStep: "The official trip is 28–30 August 2026.",
  },
  observations: {
    key: "observations",
    screenLabel: "Help — Observations",
    purpose: "Log what you see in the field, with GPS when possible.",
    actions: ["Use my location", "Pick interest", "Mark to revisit"],
    nextStep: "A photo can be linked afterwards.",
  },
  tasks: {
    key: "tasks",
    screenLabel: "Help — Tasks",
    purpose: "Organize group work. Marcel assigns. The assignee completes.",
    actions: ["Create a task and assign it", "The assignee updates status and comments", "Open tasks appear on the cockpit"],
    nextStep: "An assigned task creates an internal notice.",
  },
  gear: {
    key: "gear",
    screenLabel: "Help — Gear",
    purpose: "Shared gear list. Nothing is invented.",
    actions: ["Add only what is real", "Statuses: to bring, ready, loaded"],
    nextStep: "Mark loaded on departure morning.",
  },
  search: {
    key: "search",
    screenLabel: "Help — Search",
    purpose: "Find a message, photo, point or member.",
    actions: ["Type Desrochers or Portneuf", "Open the stay, cabin or a resource"],
    nextStep: "Search stays simple and internal.",
  },
  notifications: {
    key: "notifications",
    screenLabel: "Help — Notifications",
    purpose: "See mentions, assigned tasks and trip changes.",
    actions: ["No external push for now"],
    nextStep: "Go back to Home to act.",
  },
  admin: {
    key: "admin",
    screenLabel: "Help — Admin",
    purpose: "Invite a member and see system health.",
    actions: ["Do not invent an email", "A member without a password stays invited"],
    nextStep: "DEV and PROD versions must match.",
  },
  member: {
    key: "member",
    screenLabel: "Help — Member",
    purpose: "See a member's contributions, not a social profile.",
    actions: ["Photos, tasks, expenses"],
    nextStep: "Éric is an official organizer with Luc.",
  },
  menu: {
    key: "menu",
    screenLabel: "Help — Menu",
    purpose: "See every weekend meal and who handles it.",
    actions: ["Josée leads the food", "Natalie handles Saturday breakfast", "Each person brings their own drinks"],
    nextStep: "Open costs to enter a shared total.",
  },
  know: {
    key: "know",
    screenLabel: "Help — Before leaving",
    purpose: "Read the confirmed rules before you leave.",
    actions: ["Water is not potable", "Bring bedding", "Check SOPFEU on departure day"],
    nextStep: "Then mark items on the prep list.",
  },
  vehicles: {
    key: "vehicles",
    screenLabel: "Help — Vehicles",
    purpose: "See the real side-by-side photos. Owners stay open.",
    actions: ["Vehicle 1 and Vehicle 2", "No invented model"],
    nextStep: "Add owner and driver when known.",
  },
  nordquest: {
    key: "nordquest",
    screenLabel: "How do I install my points in NordQuest?",
    purpose: "Install NordQuest and get Eric's 9 official points.",
    actions: [
      "Install NordQuest",
      "Open Portneuf, sector 4",
      "Download the 9 points",
      "Import the KML file",
      "Check the 9 points",
      "Save the offline map",
    ],
    nextStep: "Mark yourself ready when the 9 points are on your map.",
  },
};

export function getHelpTopicRegistry(locale = "fr") {
  return locale === "en" ? EN : FR;
}

export function getHelpFallbackTopic(locale = "fr") {
  return locale === "en"
    ? { key: "__fallback__", screenLabel: "Help", purpose: "This page has no specific help yet." }
    : { key: "__fallback__", screenLabel: "Aide", purpose: "Cette page n'a pas encore d'aide précise." };
}
